<template>
  <q-footer class="bg-primary q-pt-xl q-pb-sm">
    <div class="container">
      <div class="row justify-center q-py-md">
        <div class="col-5 q-gutter-md">
          <q-btn flat dense type="a" href="https://studyingreece.edu.gr" target="_blank">
            <q-img width="150px" src="/images/study-in-greece-white-logo-transparent-en.png" />
          </q-btn>
          <span class="row text-h4 text-bold"> @SiG </span>
          <span class="row text-subtitle2">
            The all in one place<br />
            for applications and programs
          </span>
          <div class="row">
            <div class="q-gutter-md">
              <q-btn
                flat
                dense
                class="q-pa-none"
                icon="language"
                color="secondary"
                size="16px"
                href="https://studyingreece.edu.gr"
              />

              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="mdiFacebook"
                color="secondary"
                size="16px"
                href="https://www.facebook.com/studyingreece.edu/"
              />
              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="mdiInstagram"
                color="secondary"
                size="16px"
                href="https://www.instagram.com/studyingreece/"
              />
              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="mdiYoutube"
                color="secondary"
                size="16px"
                href="https://www.youtube.com/channel/UCdS8Ziod9ZWFTQ-E3Hy7NBQ"
              />
              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="mdiLinkedin"
                color="secondary"
                size="16px"
                href="https://www.linkedin.com/company/study-in-greece-official/"
              />
              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="fabXTwitter"
                color="secondary"
                size="16px"
                href="https://x.com/study_in_Greece"
              />
              <q-btn
                flat
                dense
                class="q-pa-none"
                :icon="fabTiktok"
                color="secondary"
                size="16px"
                href="https://www.tiktok.com/@studyingreece?is_from_webapp=1&sender_device=pc"
              />
            </div>
          </div>
        </div>
        <div class="col-7">
          <div class="column justify-end items-end q-gutter-sm" style="height: 100%">
            <q-btn flat no-caps :to="{ name: 'About' }">
              {{ $t('footer.about') }}
            </q-btn>
            <q-btn flat no-caps :to="{ name: 'Privacy' }" class="text-right">
              {{ $t('footer.privacy_policy') }}
            </q-btn>
            <q-btn flat no-caps :to="{ name: 'Terms' }">
              {{ $t('footer.terms_and_conditions') }}
            </q-btn>
            <q-btn flat no-caps :to="{ name: 'How To Apply' }"> How To </q-btn>
            <q-btn
              flat
              no-caps
              type="a"
              href="https://helpdesk.studyingreece.edu.gr"
              target="_blank"
            >
              HelpDesk
            </q-btn>
          </div>
        </div>
      </div>
      <q-separator color="secondary" size="3px" />
      <div class="row justify-center q-pa-md">
        <span class="text-caption text-grey">
          Study in Greece © {{ new Date().getFullYear() }}
        </span>
      </div>
    </div>
  </q-footer>
</template>
<script setup lang="ts">
import { fabTiktok, fabXTwitter } from '@quasar/extras/fontawesome-v6'
import { mdiFacebook, mdiInstagram, mdiLinkedin, mdiYoutube } from '@quasar/extras/mdi-v7'
</script>
